import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const PartnerAcquisitionChart = () => {
  const data = [
    { month: 'Jan', nouveaux: 45, actifs: 320 },
    { month: 'Fév', nouveaux: 52, actifs: 365 },
    { month: 'Mar', nouveaux: 38, actifs: 398 },
    { month: 'Avr', nouveaux: 61, actifs: 445 },
    { month: 'Mai', nouveaux: 55, actifs: 489 },
    { month: 'Jun', nouveaux: 67, actifs: 534 },
    { month: 'Jul', nouveaux: 73, actifs: 587 },
    { month: 'Aoû', nouveaux: 69, actifs: 632 },
    { month: 'Sep', nouveaux: 58, actifs: 678 }
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-popover-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <p key={index} className="text-sm" style={{ color: entry?.color }}>
              {entry?.name}: {new Intl.NumberFormat('fr-FR')?.format(entry?.value)}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-card-foreground mb-2">Acquisition de Partenaires</h3>
        <p className="text-sm text-muted-foreground">Évolution mensuelle des nouveaux partenaires et partenaires actifs</p>
      </div>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="month" 
              stroke="var(--color-muted-foreground)"
              fontSize={12}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              fontSize={12}
            />
            <Tooltip content={<CustomTooltip />} />
            <Line 
              type="monotone" 
              dataKey="nouveaux" 
              stroke="var(--color-accent)" 
              strokeWidth={3}
              name="Nouveaux partenaires"
              dot={{ fill: 'var(--color-accent)', strokeWidth: 2, r: 4 }}
            />
            <Line 
              type="monotone" 
              dataKey="actifs" 
              stroke="var(--color-success)" 
              strokeWidth={3}
              name="Partenaires actifs"
              dot={{ fill: 'var(--color-success)', strokeWidth: 2, r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PartnerAcquisitionChart;